import {Grid, Stack, Typography} from '@mui/material';
import {ColumnDef} from '@tanstack/react-table';
import {AppTable} from 'components/table';
import {AppDialog} from 'components/dialogs';
import parser from 'html-react-parser';
import {FieldTitleValuesLogModel} from 'models/logs';
import React from 'react';
import {format, parseISO, isValid} from 'date-fns';

interface LogDetailsDialogProps {
    open: boolean;
    onCloseDialog: () => void;
    FieldsData: FieldTitleValuesLogModel[];
}
export const LogDetailsDialog: React.FC<LogDetailsDialogProps> = ({open, onCloseDialog, FieldsData}) => {
    const jsonLabelGetter = (getValue: string) => {
        const value = getValue as string;
        let label = '';
        // If value is an ISO date string, format it
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?Z$/.test(value)) {
            const date = parseISO(value);
            if (isValid(date)) {
                label = format(date, 'PPpp');
            } else {
                label = value;
            }
        } else {
            try {
                const parsed = JSON.parse(value);
                label = parsed.label ?? value;
            } catch (err) {
                label = value; // fallback to raw value if not JSON
            }
        }
        return (
            <Stack direction="row" spacing={1.5} alignItems="center">
                <div>{parser(label)}</div>
            </Stack>
        );
    };
    const columns: ColumnDef<FieldTitleValuesLogModel>[] = [
        {
            header: 'Title',
            accessorKey: 'Title',
            enableSorting: false,
            cell: ({row, getValue}) => (
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Typography variant="subtitle1">{getValue() as string}</Typography>
                </Stack>
            ),
        },
        {
            header: 'Previous Value',
            accessorKey: 'PrevValue',
            enableSorting: false,
            cell: ({row, getValue}) => (getValue() ? jsonLabelGetter(getValue() as string) : null),
        },
        {
            header: 'New Value',
            accessorKey: 'NewValue',
            enableSorting: false,
            cell: ({row, getValue}) => (getValue() ? jsonLabelGetter(getValue() as string) : null),
        },
    ];
    return (
        <AppDialog
            fullWidth
            sx={{p: 3}}
            open={open}
            title={'Item Fields History'}
            onCloseDialog={onCloseDialog}
            children={
                <Grid container>
                    <Grid item xs={12}>
                        <AppTable<FieldTitleValuesLogModel>
                            data={FieldsData}
                            showPagination={false}
                            columns={columns}
                        ></AppTable>
                    </Grid>
                </Grid>
            }
        />
    );
};

export default LogDetailsDialog;
